<template>
  <main class="link-account-page">
    <div class="link-account-page__header">
      <h1 class="link-account-page__title">Link Account</h1>
      <p class="link-account-page__subtitle">Connect a subscription to your FightCamp account.</p>
    </div>

    <LinkAccountConfirmation v-if="isConfirmationFlow" />
    <LinkAccountRequestCard v-else />
  </main>
</template>

<script>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import LinkAccountConfirmation from '../link-account/LinkAccountConfirmation.vue';
import LinkAccountRequestCard from '../link-account/LinkAccountRequestCard.vue';

export default {
  name: 'LinkAccountPage',
  components: {
    LinkAccountConfirmation,
    LinkAccountRequestCard,
  },
  setup() {
    const { key, emails } = useRoute().query;
    const isConfirmationFlow = computed(() => !!(key && emails));

    return { isConfirmationFlow };
  },
};
</script>

<style lang="scss" scoped>
.link-account-page {
  padding: 2rem;
  max-width: 960px;
  width: 100%;

  &__header {
    margin-bottom: 1.5rem;
  }

  &__title {
    font-family: $font-stack-heading;
    font-size: 1.75rem;
    text-transform: uppercase;
    margin: 0 0 0.3rem;
    color: $color-black;
    letter-spacing: 0.02em;
  }

  &__subtitle {
    font-size: 0.875rem;
    color: $fc-greyscale-800;
    margin: 0;
  }
}
</style>
